import { useEffect } from "react";
import {
  useDispatch,
} from "react-redux";
import {
  notificationActions,
  getNotifications,
  Notification_Types,
} from "@sf-core";
import { toastActions } from "@base-provider";

const NotificationLayout = () => {
  useEffect(() => {
    const notificationsInterval = setInterval(() => {
      fetchNotifications();
    }, 1 * 10 * 1000);

    return () => clearInterval(notificationsInterval); //This is important
  }, []);
  const dispatch = useDispatch();

  const fetchNotifications = () => {
    getNotifications()
      .then((res) => {
        if (res && res.data) {
          //we're showing toasts only for the ones that are not delivered and are popups
          let toasts = res.data.filter((x) => x.isPopup && !x.sentAt);
          if (toasts.length > 0) {
            toasts.forEach((toast) => {
              switch (toast.type) {
              case Notification_Types.INFO:
              default:
                dispatch(toastActions.showInfoMessage(toast));
                break;
              case Notification_Types.SUCCESS:
                dispatch(toastActions.showSuccessMessage(toast));
                break;
              case Notification_Types.ERROR:
                dispatch(toastActions.showErrorMessage(toast));
                break;
              case Notification_Types.WARNING:
                dispatch(toastActions.showWarningMessage(toast));
                break;
              }
            });
          }
          dispatch(notificationActions.setNotifications(res.data));
        }
      })
      .catch((error) => {
        //error management
      });
  };

  return null;
};

export default NotificationLayout;